import { Injectable } from '@angular/core';
import {
  preventLeaveEditing,
  resetLeavePageActionResult
} from '@app/core/leave-page-handler/actions/leave-page-internal';
import { isCancelAction } from '@app/core/leave-page-handler/reducers/leave-page';
import * as fromPcs from '@app/pcs/reducer';
import { isTrue, takeOne } from '@app/util';
import { Action, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { skipWhile, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class LeavePageService {

  constructor(private store: Store<fromPcs.State>) {
  }

  /**
   * <p> Performs a check if page can be left.
   * <p> In case when form is dirty => open modal for unsaved changes
   * <ul>
   *   <li>case 1: formDirty = false => go to the next page w/o any confirmations </li>
   *   <li>case 2: formDirty = true && action = null => prevent navigation and open modal for unsaved changes </li>
   *   <li>case 3: action = Cancel => close modal and stay on the same page </li>
   *   <li>case 4: action = Confirm => close modal and navigate to the next page </li>
   * </ul>
   * @param confirmActions actions that should be executed in case when there is navigation
   */
  check(confirmActions: Action[] = []): Observable<boolean> {
    return this.store.pipe(select(fromPcs.getLeavePageState)).pipe(
      tap(({formStatusInfo: {formDirty}, action}: any) => {
        if (formDirty && !action) {
          this.store.dispatch(preventLeaveEditing(confirmActions));
        }
      }),
      skipWhile(({formStatusInfo: {formDirty}, action}: any) => action ? false : isTrue(formDirty)),
      takeOne(),
      switchMap(({formStatusInfo: {formDirty}, action}: any) =>  of(!formDirty || !isCancelAction(action))),
      tap(() => this.store.dispatch(resetLeavePageActionResult()))
    );
  }

}
